module.exports = __webpack_public_path__ + "static/img/Boss_31090.23ddfd19.png";